import React from 'react'
import { TextAreaInput } from '@ztechapps/webui.input'
import { useContext } from '../Context'
import type { ChatInputProps } from '../chatComponents'

export const ChatInput = ({ placeholder = 'Enter a message.' }: ChatInputProps) => {
  const { message, setMessage, status, setChatInputCursorPosition } = useContext()

  const inputRef = React.useRef<any>(null)

  const onBlur = () => {
    const position = inputRef?.current?.selectionStart ?? 0
    setChatInputCursorPosition(position)
  }

  return (
    <TextAreaInput
      inputRef={inputRef}
      rows={3}
      value={message}
      disabled={status?.sending}
      onChange={(e) => setMessage(e?.target?.value)}
      placeholder={placeholder}
      onBlur={onBlur}
    />
  )
}
